import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, mapMany } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Observable } from "rxjs";

export interface Props {
    entregas: Observable<models.EntregaZERealizadaDTO[]>;
}

const columns: kea.Grid2Column<models.RecordatorioAcuse>[] = [
    { title: "Folio", cell: x => ({ data: x.Folio }) },
    { title: "Tipo de acuse", cell: x => ({ data: x.TipoAcuse == null ? null : models.TipoAcuse[x.TipoAcuse] }) },
    { title: "Requerimiento acuse externo", cell: x => ({ data: x.RequerimientoAcuse }) }
];

const Alerta = () =>
    <div className="alert alert-info">
        <label>
            <i className={fa("file-o", "fw")} />
            Se generarán los siguientes acuses
        </label>
        <br />
        Al finalizar la liberación se generará una guia de acuse por cada una de estas guias:
    </div>;

/**
 * Muestra el listado de las guias que van a generar acuses
 */
export class AcusesList extends React.PureComponent<Props> {
    entregas = (props: Props) => props.entregas;
    entregasFltradas = createSelectorRx(this.entregas, entregas => entregas.filter(x => x.AcusesEntregar.length > 0));
    conAcuses = createSelectorRx(this.entregasFltradas, entregasFltradas => mapMany(entregasFltradas, x => x.AcusesEntregar));

    render() {
        return (
            <div>
                <Alerta />
                <kea.Grid2 items={this.conAcuses(this.props)} columnas={columns} />
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/acuses/index.tsx